import { onWcEvent } from '../functions/wcEventHelper';

export default class WCCartTaxSwitch {
    constructor() {
        this.cartEvents();
    }

    cartEvents() {
        onWcEvent(
            ['wc_fragments_refreshed', 'updated_shipping_method'],
            (addCleanup) => {
                this.setListenersToEvents(addCleanup);
            },
        );
    }

    setListenersToEvents(addCleanup) {
        this.cartTaxesSwitch = document.querySelector('.jsWcCartTaxesSwitch');
        this.cartTaxesInfo = document.querySelector('.jsWcCartTaxesInfo');
        this.cartTaxesIndicator = document.querySelector(
            '.jsWcCartTaxesIndicator',
        );

        if (this.cartTaxesSwitch) {
            const handler = this.toggleTaxes.bind(this);
            this.cartTaxesSwitch.addEventListener('change', handler);
            addCleanup(() =>
                this.cartTaxesSwitch.removeEventListener('change', handler),
            );

            if (this.cartTaxesInfo) this.toggleTaxesInfo();
            if (this.cartTaxesIndicator) this.toggleTaxesIndicator();
        }
    }

    toggleTaxes() {
        this.toggleTaxesInfo();
        this.toggleTaxesIndicator();
        this.updateCart();
    }

    toggleTaxesInfo() {
        if (this.cartTaxesSwitch.checked) {
            this.cartTaxesInfo.classList.remove('is-hidden');
        } else {
            this.cartTaxesInfo.classList.add('is-hidden');
        }
    }

    toggleTaxesIndicator() {
        if (this.cartTaxesSwitch.checked) {
            this.cartTaxesIndicator.value = '1';
        } else {
            this.cartTaxesIndicator.value = '0';
        }
    }

    updateCart() {
        const wcCartUpdateCartBtn = document.querySelector(
            '.jsWCCartUpdateCartBtn',
        );

        if (!wcCartUpdateCartBtn) return;

        wcCartUpdateCartBtn.setAttribute('aria-disabled', 'false');
        wcCartUpdateCartBtn.removeAttribute('disabled');
        wcCartUpdateCartBtn.click();
    }
}
